import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import {
  FLIGHT_ISSUANCE_API_PATH,
  FINANCIAL_PROFILE_API_PATH,
  FLIGHT_ISSUANCE_SALES_USER_API_PATH,
  FLIGHTS_PROMO_API_PATH,
} from "@/core/constants/apiEndPoints";
import {
  FETCH_FLIGHT_PNR_PAYLOAD,
  ISSUE_TICKET_PAYLOAD,
  PRICE_QUOTE_FARE_CALCULATION_PAYLOAD,
} from "@/core/types/flight";
import { GetFinancialProfileDto } from "@/modules/FlightIssuance/dtos/financialProfile.dto";
import { ApplyFlightPromoCodeDTO } from "@/modules/FlightIssuance/dtos/flightIssuance.dto";

class FlightIssuanceService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public fetchPNR(params: FETCH_FLIGHT_PNR_PAYLOAD): Promise<ICoreResponse> {
    return this.restClient.post(FLIGHT_ISSUANCE_API_PATH.PNR_DETAILS, params);
  }

  public fetchPNRV3(params: FETCH_FLIGHT_PNR_PAYLOAD): Promise<ICoreResponse> {
    return this.restClient.post(
      FLIGHT_ISSUANCE_API_PATH.PNR_DETAILS_V3,
      params,
    );
  }

  public calculatePriceQuoteFare(
    params: PRICE_QUOTE_FARE_CALCULATION_PAYLOAD,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      FLIGHT_ISSUANCE_API_PATH.PQ_CALCULATE_FARE,
      params,
    );
  }

  public issueTicket(params: ISSUE_TICKET_PAYLOAD): Promise<ICoreResponse> {
    const ISSUE_TICKET_ENDPOINT =
      params?.fare_public_ids && params?.fare_public_ids?.length > 0
        ? FLIGHT_ISSUANCE_API_PATH.ISSUE_TICKET_V3
        : FLIGHT_ISSUANCE_API_PATH.ISSUE_TICKET;
    return this.restClient.post(ISSUE_TICKET_ENDPOINT, params);
  }

  // ******** Fetch Financial Profiles ***********
  public getAllFinancialProfiles(
    params?: GetFinancialProfileDto,
  ): Promise<ICoreResponse> {
    return this.restClient.get(
      FINANCIAL_PROFILE_API_PATH.GET_ALL,
      params || {},
    );
  }

  // ******** Fetch Sales Users List For Approval To Issue Ticket ***********
  public getSalesUsersListForIssanceApproval(): Promise<ICoreResponse> {
    return this.restClient.get(
      FLIGHT_ISSUANCE_SALES_USER_API_PATH.GET_SALES_USER,
    );
  }

  public applyFlightsPromoCode(
    body: ApplyFlightPromoCodeDTO,
  ): Promise<ICoreResponse> {
    return this.restClient.post(FLIGHTS_PROMO_API_PATH.APPLY_PROMO, body);
  }
  public applyFlightsPromoCodeV2(
    body: ApplyFlightPromoCodeDTO,
  ): Promise<ICoreResponse> {
    return this.restClient.post(FLIGHTS_PROMO_API_PATH.APPLY_PROMO_V2, body);
  }
}

export default FlightIssuanceService;
